import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { get } from 'lodash';
import { NEXA_LEGAL_ACCEPTANCE_KEY } from '@src/utils/constants/controls';

// Controls store for managing customer control states

interface ControlItem {
  status: boolean;
  value: string | null;
}

interface ControlsState {
  items: Record<string, ControlItem>;
  setAll: (items: Record<string, ControlItem>) => void;
  clear: () => void;
}

export const useControlsStore = create<ControlsState>()(
  devtools(
    (set) => ({
      items: {},
      setAll: (items) => set({ items }),
      clear: () => set({ items: {} }),
    }),
    { name: 'controlsStore' },
  ),
);

// Without subscription - for use in utility functions
export const getNexaControl = (): ControlItem | null => {
  const items = useControlsStore.getState().items;
  return get(items, NEXA_LEGAL_ACCEPTANCE_KEY, null);
};

// With subscription - for use in components
export const useNexaControl = (): ControlItem | null => {
  const items = useControlsStore((state) => state.items);
  return get(items, NEXA_LEGAL_ACCEPTANCE_KEY, null);
};
